import { trackEvent } from "./googleAnalytics";

const viewedSections = new Set();
const scrolledDepths = new Set();

/**
 * Fires section_viewed once per page load for a given section id.
 */
export const trackSectionViewed = (section) => {
  if (!section || viewedSections.has(section)) {
    return;
  }
  viewedSections.add(section);
  trackEvent("section_viewed", { section });
};

/**
 * Fires page_scroll_depth once per threshold per page load.
 */
export const trackScrollDepth = (percent) => {
  if (typeof percent !== "number" || scrolledDepths.has(percent)) {
    return;
  }
  scrolledDepths.add(percent);
  trackEvent("page_scroll_depth", { percent });
};

export const PRODUCT_ANALYTICS_IDS = {
  1: "x_translator",
  2: "x_raster",
  3: "neplan_interface",
  4: "interlis_interface",
  5: "isybau_interface",
  6: "services",
};

export const getProductAnalyticsId = (feature) =>
  PRODUCT_ANALYTICS_IDS[feature?.id] || `product_${feature?.id || "unknown"}`;

export const getPartnerAnalyticsId = (alt) =>
  String(alt || "unknown")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

export const TRACKED_SECTIONS = [
  "hero",
  "works",
  "products",
  "new_feature",
  "downloads",
  "partners",
  "testimonials",
  "footer",
];
